import React from 'react'
import { SiteConfiguration } from '@matech/thebigpos-sdk'
import { useIntl } from 'react-intl'
import Dialog, { DialogProps } from '../Dialog'
import AutoTaskRemindersForm from '../../../forms/AutoTaskRemindersForm/AutoTaskRemindersForm'

export type BaseModalAutoTaskRemindersProps = {
	data?: SiteConfiguration['autoTaskReminderIntervalsInDays']
	onSubmit?: (
		value: SiteConfiguration['autoTaskReminderIntervalsInDays']
	) => void
}
export type ModalAutoTaskRemindersProps = Omit<
	DialogProps,
	'onSubmit'
> &
	BaseModalAutoTaskRemindersProps & {
		siteConfiguration?: SiteConfiguration
	}

const ModalAutoTaskReminders = ({
	data,
	onClose,
	onSubmit,
	...rest
}: ModalAutoTaskRemindersProps) => {
	const { formatMessage } = useIntl()

	const handleSubmit = async (
		autoTaskReminderIntervalsInDays: SiteConfiguration['autoTaskReminderIntervalsInDays']
	) => {
		if (!data) {
			return
		}
		onSubmit?.(autoTaskReminderIntervalsInDays)
		onClose?.()
	}

	if (data === undefined) {
		return null
	}
	return (
		<Dialog
			title={formatMessage({ id: 'auto_task_reminders.title' })}
			onClose={onClose}
			fullWidth
			{...rest}
		>
			<div className="max-w-md mx-auto">
				<AutoTaskRemindersForm
					autoTaskReminderIntervalsInDays={data}
					onSubmit={handleSubmit}
				/>
			</div>
		</Dialog>
	)
}

export default ModalAutoTaskReminders
